import React, { useContext } from "react";
import PopupContext from "@stores/popup-context";
import { IconArrowLeft, IconArrowRight, IconInfo } from "@ui/icons";
import { Link as RouterLink } from "react-router-dom";
import { getTextColourCss, getFontSizeCss } from "@helpers/css-convertions";

const iconCss = "w-4 h-4 md:w-5 md:h-5";
const supportedIcons = {
    RightArrow: <IconArrowRight className={iconCss} />,
    LeftArrow: <IconArrowLeft className={iconCss} />,
    Info: <IconInfo className={iconCss} />,
};
const Icon = ({ iconType }) => {
    var cmpIcon = supportedIcons[iconType];
    return cmpIcon ?? null;
};

const Bold = ({ value }) => {
    return <b>{value}</b>;
};

const NewLine = ({}) => {
    return <br />;
};

const Super = ({ value }) => {
    return <sup>{value}</sup>;
};

const Italics = ({ value }) => {
    return <i>{value}</i>;
};

const tagsCmp = {
    span: (value, attr) => <span {...attr}>{value}</span>,
    h1: (value, attr) => <h1 {...attr}>{value}</h1>,
    h2: (value, attr) => <h2 {...attr}>{value}</h2>,
    h3: (value, attr) => <h3 {...attr}>{value}</h3>,
    h4: (value, attr) => <h4 {...attr}>{value}</h4>,
};
const RichText = (props) => {
    var cmp = tagsCmp[props.tag ?? 'span'];
    if (!cmp) return null;

    const colourCss = getTextColourCss(props?.font?.colour) ?? '';

    const sizeCss = getFontSizeCss(props?.font?.value) ?? ''

    const className = `${props?.font?.isBold ? 'font-semibold' : ''} ${
        props.noWrap ? 'whitespace-nowrap' : ''
    } ${colourCss} ${sizeCss}`;

    return cmp(props.value, {
        className: className,
    });
};


const LinkDefault = ({
    target,
    value,
    url,
    isExternal,
    postTextIcon,
    preTextIcon,
}) => {
    if (isExternal) {
        return (
            <a
                className="inline items-center text-skin-primary"
                href={url}
                target={target}
            >
                <Icon iconType={preTextIcon} />
                {value}
                <Icon iconType={postTextIcon} />
            </a>
        );
    }
    return (
        <RouterLink
            to={url}
            className="inline-flex text-skin-primary"
            target={target}
        >
            <Icon iconType={preTextIcon} />
            {value}
            <Icon iconType={postTextIcon} />
        </RouterLink>
    );
};

const LinkPopup = ({
    target,
    value,
    url,
    popupWidth,
    popupHeight,
    attributes,
    postTextIcon,
    preTextIcon,
}) => {
    const cxt = useContext(PopupContext);

    const handleClick = (e) => {
        e.preventDefault();
        const att = attributes ?? {};
        cxt.open(url, null, popupWidth, popupHeight);
    };

    return (
        <a
            className="text-sm text-skin-primary"
            onClick={handleClick}
            href={url}
            target={target}
            {...attributes}
        >
            <Icon iconType={preTextIcon} />
            {value}
            <Icon iconType={postTextIcon} />
        </a>
    );
};

const Link = (props) => {
    return props.linkType === "Popup" ? (
        <LinkPopup {...props} />
    ) : (
        <LinkDefault {...props} />
    );
};

const emptyAlt = (value) => {
    if (value === null || value === undefined) return "";
    if (value === " ") return "\u00A0";
    return value;
};

const ComplexTextPart = (props) => {
    if (props.type === "bold") return Bold(props);
    else if (props.type === "superscript") return Super(props);
    else if (props.type === "link") return Link(props);
    else if (props.type === "italics") return Italics(props);
    else if (props.value === "\n") return NewLine(props);
    else if (props.type === "newline") return NewLine(props);
    else if (props.type === "richtext") return RichText(props);

    return <>{emptyAlt(props.value)}</>;
};

const ComplexText = ({ values }) => {
    return (
        <>
            {values &&
                values.map((t, i) => (
                    <ComplexTextPart key={i} {...t}></ComplexTextPart>
                ))}
        </>
    );
};

export default ComplexText;
